export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      about: 'Qui sommes-nous',
      program: 'Programme',
      contact: 'Contact'
    },
    home: {
      heroTitle: "APPRENEZ L'ANGLAIS EN FAMILLE",
      heroSubtitle: 'Une expérience immersive unique dans le Territoire de Belfort',
      discoverProgram: 'Découvrir le programme',
      contactUs: 'Nous contacter',
      visionTitle: 'Notre Vision',
      visionText: "Offrir une expérience immersive d'apprentissage de l'anglais tout en promouvant les échanges culturels, dans un cadre familial chaleureux et inclusif.",
      whyTitle: 'Pourquoi choisir TEREKA ?',
      feature1Title: 'Échanges Culturels',
      feature1Text: "Découvrez une nouvelle culture tout en pratiquant l'anglais au quotidien",
      feature2Title: 'Cadre Familial',
      feature2Text: 'Apprenez dans un environnement chaleureux et convivial',
      feature3Title: 'Pratique Quotidienne',
      feature3Text: 'cours et conversations en anglais',
      feature4Title: 'Suivi Personnalisé',
      feature4Text: 'Un accompagnement sur mesure pour chaque famille',
      howTitle: 'Comment ça marche ?',
      step1Title: 'Contactez-nous',
      step1Text: 'Partagez vos attentes et vos besoins avec notre équipe',
      step2Title: 'Sélection',
      step2Text: "Nous choisissons l'anglophone qui correspond à votre famille",
      step3Title: 'Mise en relation',
      step3Text: 'Rencontrez votre futur locuteur anglophone',
      step4Title: 'Immersion',
      step4Text: 'Vivez une expérience enrichissante de 1 à 3 mois',
      testimonialsTitle: 'Ils nous font confiance',
      ctaTitle: "Prêt à commencer l'aventure ?",
      ctaText: "Rejoignez les familles qui ont déjà fait le choix d'une immersion anglophone enrichissante",
      ctaButton: 'Inscrivez-vous maintenant'
    },
    about: {
      title: 'QUI SOMMES-NOUS',
      subtitle: 'Une équipe passionnée au service des échanges culturels',
      missionTitle: 'Notre Mission',
      mission1: "Créer des relations enrichissantes entre des familles françaises et des anglophones en favorisant des échanges interculturels et une pratique quotidienne de l'anglais.",
      mission2: "Nous permettons à des familles françaises locales de pratiquer l'anglais de manière régulière en conversant avec un anglophone natif, tout en créant une dynamique autour de l'apprentissage et des échanges interculturels.",
      valuesTitle: 'Nos Valeurs',
      value1Title: 'Bienveillance',
      value1Text: 'Nous cultivons un environnement chaleureux et accueillant pour tous',
      value2Title: 'Qualité',
      value2Text: 'Nous sélectionnons avec soin chaque anglophone pour garantir une expérience exceptionnelle',
      value3Title: 'Engagement',
      value3Text: 'Nous assurons un suivi personnalisé tout au long du séjour',
      value4Title: 'Respect',
      value4Text: 'Nous valorisons la diversité culturelle et les échanges mutuels',
      teamTitle: 'Équipe TEREKA',
      teamSubtitle: "Des professionnels dévoués à l'éducation et aux échanges culturels",
      territoryTitle: 'Notre Territoire',
      territory1: "Nous sommes fiers d'opérer dans le Territoire de Belfort, une région riche en histoire et en culture. Le Lion de Belfort, symbole de résistance et de fierté, représente parfaitement nos valeurs de courage et d'engagement.",
      territory2: "C'est dans ce cadre exceptionnel que nous proposons aux familles locales et des alentours de vivre une expérience d'immersion anglophone unique.",
      ctaQuestion: 'Une question sur notre association ?',
      ctaText: "N'hésitez pas à nous contacter pour en savoir plus",
      ctaButton: 'Contactez-nous'
    },
    program: {
      title: 'NOTRE PROGRAMME',
      subtitle: 'Une immersion anglophone adaptée à vos besoins',
      offerTitle: 'Notre Offre',
      offer1: "Plus enrichissant et formateur qu'un stage en anglais, notre programme propose de pratiquer l'anglais en accueillant un anglophone dans votre famille pour une durée de 1 à 3 mois maximum.",
      offer2: "En échange du logement et des repas pris en famille, l'anglophone propose 15 heures de cours d'anglais, soutien scolaire et conversation par semaine aux membres de la famille (parents et enfants).",
      advantagesTitle: 'Les Avantages du Programme',
      includedTitle: 'Ce qui est inclus',
      included1Title: 'Sélection personnalisée',
      included1Text: "Nous choisissons l'anglophone qui correspond à vos attentes et à votre profil familial",
      included2Title: 'Mise en relation',
      included2Text: 'Accompagnement complet lors de la rencontre et du début du séjour',
      included3Title: 'Suivi régulier',
      included3Text: "Points réguliers avec la famille et l'anglophone tout au long du séjour",
      included4Title: 'Support continu',
      included4Text: 'Équipe disponible pour répondre à vos questions et préoccupations',
      included5Title: 'Ateliers communautaires',
      included5Text: 'Possibilité pour les anglophones de participer à des interventions dans les écoles locales',
      included6Title: 'Immersion culturelle',
      included6Text: 'Découverte mutuelle des cultures française et anglophone',
      processTitle: 'Le Processus en Détail',
      process1Title: 'Premier Contact',
      process1Text: 'Vous nous contactez via notre formulaire ou par téléphone. Nous échangeons sur vos attentes, vos besoins spécifiques et le profil de votre famille.',
      process2Title: "Sélection de l'Anglophone",
      process2Text: "Notre équipe analyse votre demande et sélectionne l'anglophone le plus adapté à votre famille. Nous prenons en compte les personnalités, les intérêts et les objectifs d'apprentissage.",
      process3Title: 'Rencontre et Mise en Relation',
      process3Text: "Organisation d'une rencontre entre votre famille et l'anglophone pour faire connaissance. Nous facilitons cette première prise de contact.",
      process4Title: 'Début du Séjour',
      process4Text: "L'anglophone intègre votre foyer et commence les cours d'anglais. Un planning est établi ensemble pour les 15 heures hebdomadaires.",
      process5Title: 'Suivi et Accompagnement',
      process5Text: "Tout au long du séjour, notre équipe reste en contact avec vous et l'anglophone pour s'assurer que tout se passe bien et ajuster si nécessaire.",
      faqTitle: 'Questions Fréquentes',
      ctaQuestion: 'Intéressé par notre programme ?',
      ctaText: "Contactez-nous pour discuter de vos besoins et commencer l'aventure",
      ctaButton: 'Nous contacter'
    },
    contact: {
      title: 'CONTACTEZ-NOUS',
      subtitle: 'Nous sommes là pour répondre à toutes vos questions',
      addressTitle: 'Adresse',
      addressText: 'Territoire de Belfort',
      addressCountry: 'France',
      emailTitle: 'Email',
      phoneTitle: 'Téléphone',
      simpleContact: 'Contact Simple',
      registration: 'Inscription au Programme',
      formTitle: 'Envoyez-nous un message',
      formSubtitle: "Vous avez une question ? N'hésitez pas à nous contacter",
      nameLabel: 'Nom complet',
      namePlaceholder: 'Votre nom',
      emailLabel: 'Email',
      emailPlaceholder: 'votre@email.com',
      phoneLabel: 'Téléphone',
      phonePlaceholder: '+33 X XX XX XX XX',
      messageLabel: 'Message',
      messagePlaceholder: 'Votre message...',
      sendButton: 'Envoyer',
      sending: 'Envoi en cours...',
      registrationTitle: 'Inscription au Programme',
      registrationSubtitle: "Remplissez ce formulaire pour participer à notre programme d'immersion anglophone",
      familyNameLabel: 'Nom de famille',
      familyNamePlaceholder: 'Famille Dupont',
      addressLabel: 'Adresse',
      addressPlaceholder: 'Votre adresse complète',
      familyMembersLabel: 'Nombre de membres',
      familyMembersPlaceholder: 'Ex: 2 adultes, 2 enfants',
      durationLabel: 'Durée souhaitée',
      durationPlaceholder: 'Ex: 2 mois',
      expectationsLabel: 'Vos attentes et objectifs',
      expectationsPlaceholder: "Parlez-nous de vos attentes, objectifs d'apprentissage, préférences...",
      registerButton: "S'inscrire",
      successMessage: 'Merci ! Nous vous répondrons sous 48h.',
      registrationSuccess: 'Votre demande a été enregistrée avec succès !',
      errorMessage: 'Une erreur est survenue. Veuillez réessayer.'
    },
    footer: {
      description: "Favoriser les échanges culturels et l'apprentissage de l'anglais dans un cadre familial chaleureux.",
      navigation: 'Navigation',
      contactTitle: 'Contact',
      rights: 'Tous droits réservés.'
    },
    features: {
      feature1: {
        title: 'Durée flexible',
        description: 'Programme de 1 à 3 mois selon vos besoins'
      },
      feature2: {
        title: '15h par semaine',
        description: "Cours d'anglais, soutien scolaire et conversation"
      },
      feature3: {
        title: 'Immersion totale',
        description: 'Logement et repas en famille'
      },
      feature4: {
        title: 'Suivi personnalisé',
        description: "Accompagnement de l'association tout au long du séjour"
      }
    },
    faqs: {
      q1: "Comment se déroule la sélection de l'anglophone ?",
      a1: 'Nous prenons en compte vos attentes, vos besoins et votre profil familial pour vous proposer un anglophone qui correspond parfaitement à vos critères.',
      q2: 'Quelle est la durée minimale du programme ?',
      a2: "La durée minimale est d'un mois et peut aller jusqu'à 3 mois maximum. Cela permet de créer une vraie dynamique d'apprentissage.",
      q3: 'Qui peut participer au programme ?',
      a3: 'Toutes les familles du territoire de Belfort et des alentours souhaitant offrir à leurs membres une immersion anglophone enrichissante.',
      q4: 'Quel est le coût du programme ?',
      a4: "L'échange repose sur le principe du logement et des repas fournis par la famille en contrepartie des 15 heures de cours d'anglais hebdomadaires. L'association facture des frais de mise en relation et de suivi."
    },
    team: {
      member1: {
        name: 'Marie Dubois',
        role: 'Fondatrice',
        bio: "Passionnée par les échanges culturels, j'ai créé TEREKA pour permettre aux familles de vivre une expérience d'apprentissage unique."
      },
      member2: {
        name: 'Jean Martin',
        role: 'Coordinateur',
        bio: "Fort de 10 ans d'expérience dans l'éducation, je m'assure que chaque placement correspond aux attentes de nos familles."
      },
      member3: {
        name: 'Sophie Laurent',
        role: 'Responsable des échanges',
        bio: 'Je supervise le suivi des anglophones et des familles pour garantir une expérience enrichissante pour tous.'
      }
    },
    testimonials: {
      t1: {
        name: 'Famille Rousseau',
        location: 'Belfort',
        text: "Une expérience formidable ! Nos enfants ont progressé en anglais tout en créant des liens d'amitié exceptionnels avec notre anglophone."
      },
      t2: {
        name: 'Famille Petit',
        location: 'Territoire de Belfort',
        text: "Plus qu'un simple cours d'anglais, c'est un véritable échange culturel qui a enrichi toute notre famille."
      },
      t3: {
        name: 'Sarah Johnson',
        location: 'Angleterre',
        text: "J'ai adoré mon séjour avec TEREKA. La famille m'a accueillie chaleureusement et j'ai découvert la belle région de Belfort."
      }
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      program: 'Program',
      contact: 'Contact'
    },
    home: {
      heroTitle: 'LEARN ENGLISH AS A FAMILY',
      heroSubtitle: 'A unique immersive experience in the Belfort Territory',
      discoverProgram: 'Discover the program',
      contactUs: 'Contact us',
      visionTitle: 'Our Vision',
      visionText: 'To offer an immersive English learning experience while promoting cultural exchanges in a warm and inclusive family setting.',
      whyTitle: 'Why choose TEREKA?',
      feature1Title: 'Cultural Exchanges',
      feature1Text: 'Discover a new culture while practicing English daily',
      feature2Title: 'Family Setting',
      feature2Text: 'Learn in a warm and friendly environment',
      feature3Title: 'Daily Practice',
      feature3Text: 'lessons and English conversations',
      feature4Title: 'Personalized Follow-up',
      feature4Text: 'Tailored support for each family',
      howTitle: 'How does it work?',
      step1Title: 'Contact us',
      step1Text: 'Share your expectations and needs with our team',
      step2Title: 'Selection',
      step2Text: 'We choose the English speaker that matches your family',
      step3Title: 'Connection',
      step3Text: 'Meet your future English speaker',
      step4Title: 'Immersion',
      step4Text: 'Experience an enriching 1 to 3 month journey',
      testimonialsTitle: 'They trust us',
      ctaTitle: 'Ready to start the adventure?',
      ctaText: 'Join the families who have already chosen an enriching English immersion',
      ctaButton: 'Sign up now'
    },
    about: {
      title: 'ABOUT US',
      subtitle: 'A passionate team dedicated to cultural exchanges',
      missionTitle: 'Our Mission',
      mission1: 'To create enriching relationships between French families and English speakers by promoting intercultural exchanges and daily English practice.',
      mission2: 'We enable local French families to practice English regularly by conversing with a native English speaker, while creating a dynamic around learning and intercultural exchanges.',
      valuesTitle: 'Our Values',
      value1Title: 'Kindness',
      value1Text: 'We cultivate a warm and welcoming environment for everyone',
      value2Title: 'Quality',
      value2Text: 'We carefully select each English speaker to guarantee an exceptional experience',
      value3Title: 'Commitment',
      value3Text: 'We ensure personalized follow-up throughout the stay',
      value4Title: 'Respect',
      value4Text: 'We value cultural diversity and mutual exchanges',
      teamTitle: 'TEREKA Team',
      teamSubtitle: 'Professionals dedicated to education and cultural exchanges',
      territoryTitle: 'Our Territory',
      territory1: 'We are proud to operate in the Belfort Territory, a region rich in history and culture. The Lion of Belfort, symbol of resistance and pride, perfectly represents our values of courage and commitment.',
      territory2: 'It is in this exceptional setting that we offer local families and surrounding areas to experience a unique English immersion.',
      ctaQuestion: 'Questions about our organization?',
      ctaText: 'Feel free to contact us to learn more',
      ctaButton: 'Contact us'
    },
    program: {
      title: 'OUR PROGRAM',
      subtitle: 'An English immersion adapted to your needs',
      offerTitle: 'Our Offer',
      offer1: 'More enriching and educational than an English course, our program offers to practice English by welcoming an English speaker into your family for a duration of 1 to 3 months maximum.',
      offer2: 'In exchange for accommodation and meals with the family, the English speaker offers 15 hours of English lessons, academic support and conversation per week to family members (parents and children).',
      advantagesTitle: 'Program Benefits',
      includedTitle: "What's included",
      included1Title: 'Personalized selection',
      included1Text: 'We choose the English speaker that matches your expectations and family profile',
      included2Title: 'Connection',
      included2Text: 'Complete support during the meeting and start of the stay',
      included3Title: 'Regular follow-up',
      included3Text: 'Regular check-ins with the family and English speaker throughout the stay',
      included4Title: 'Continuous support',
      included4Text: 'Team available to answer your questions and concerns',
      included5Title: 'Community workshops',
      included5Text: 'Opportunity for English speakers to participate in interventions in local schools',
      included6Title: 'Cultural immersion',
      included6Text: 'Mutual discovery of French and English-speaking cultures',
      processTitle: 'The Process in Detail',
      process1Title: 'First Contact',
      process1Text: 'You contact us via our form or by phone. We discuss your expectations, specific needs and your family profile.',
      process2Title: 'English Speaker Selection',
      process2Text: 'Our team analyzes your request and selects the most suitable English speaker for your family. We consider personalities, interests and learning objectives.',
      process3Title: 'Meeting and Connection',
      process3Text: 'Organization of a meeting between your family and the English speaker to get acquainted. We facilitate this first contact.',
      process4Title: 'Stay Begins',
      process4Text: 'The English speaker joins your home and begins English lessons. A schedule is established together for the 15 weekly hours.',
      process5Title: 'Follow-up and Support',
      process5Text: 'Throughout the stay, our team remains in contact with you and the English speaker to ensure everything goes well and adjust if necessary.',
      faqTitle: 'Frequently Asked Questions',
      ctaQuestion: 'Interested in our program?',
      ctaText: 'Contact us to discuss your needs and start the adventure',
      ctaButton: 'Contact us'
    },
    contact: {
      title: 'CONTACT US',
      subtitle: 'We are here to answer all your questions',
      addressTitle: 'Address',
      addressText: 'Belfort Territory',
      addressCountry: 'France',
      emailTitle: 'Email',
      phoneTitle: 'Phone',
      simpleContact: 'Simple Contact',
      registration: 'Program Registration',
      formTitle: 'Send us a message',
      formSubtitle: 'Have a question? Feel free to contact us',
      nameLabel: 'Full name',
      namePlaceholder: 'Your name',
      emailLabel: 'Email',
      emailPlaceholder: 'your@email.com',
      phoneLabel: 'Phone',
      phonePlaceholder: '+33 X XX XX XX XX',
      messageLabel: 'Message',
      messagePlaceholder: 'Your message...',
      sendButton: 'Send',
      sending: 'Sending...',
      registrationTitle: 'Program Registration',
      registrationSubtitle: 'Fill out this form to participate in our English immersion program',
      familyNameLabel: 'Family name',
      familyNamePlaceholder: 'Dupont Family',
      addressLabel: 'Address',
      addressPlaceholder: 'Your complete address',
      familyMembersLabel: 'Number of members',
      familyMembersPlaceholder: 'E.g.: 2 adults, 2 children',
      durationLabel: 'Desired duration',
      durationPlaceholder: 'E.g.: 2 months',
      expectationsLabel: 'Your expectations and goals',
      expectationsPlaceholder: 'Tell us about your expectations, learning goals, preferences...',
      registerButton: 'Register',
      successMessage: 'Thank you! We will respond within 48 hours.',
      registrationSuccess: 'Your request has been successfully registered!',
      errorMessage: 'An error occurred. Please try again.'
    },
    footer: {
      description: 'Promoting cultural exchanges and English learning in a warm family setting.',
      navigation: 'Navigation',
      contactTitle: 'Contact',
      rights: 'All rights reserved.'
    },
    features: {
      feature1: {
        title: 'Flexible duration',
        description: '1 to 3 month program according to your needs'
      },
      feature2: {
        title: '15h per week',
        description: 'English lessons, academic support and conversation'
      },
      feature3: {
        title: 'Total immersion',
        description: 'Accommodation and meals with family'
      },
      feature4: {
        title: 'Personalized follow-up',
        description: 'Association support throughout the stay'
      }
    },
    faqs: {
      q1: 'How does the English speaker selection work?',
      a1: 'We take into account your expectations, needs and family profile to propose an English speaker who perfectly matches your criteria.',
      q2: 'What is the minimum program duration?',
      a2: 'The minimum duration is one month and can go up to 3 months maximum. This allows for creating a real learning dynamic.',
      q3: 'Who can participate in the program?',
      a3: 'All families from the Belfort territory and surrounding areas wishing to offer their members an enriching English immersion.',
      q4: 'What is the cost of the program?',
      a4: 'The exchange is based on the principle of accommodation and meals provided by the family in return for 15 hours of weekly English lessons. The association charges connection and follow-up fees.'
    },
    team: {
      member1: {
        name: 'Marie Dubois',
        role: 'Founder',
        bio: 'Passionate about cultural exchanges, I created TEREKA to allow families to experience a unique learning experience.'
      },
      member2: {
        name: 'Jean Martin',
        role: 'Coordinator',
        bio: 'With 10 years of experience in education, I ensure that each placement matches our families expectations.'
      },
      member3: {
        name: 'Sophie Laurent',
        role: 'Exchange Manager',
        bio: 'I oversee the follow-up of English speakers and families to guarantee an enriching experience for all.'
      }
    },
    testimonials: {
      t1: {
        name: 'Rousseau Family',
        location: 'Belfort',
        text: 'A wonderful experience! Our children improved their English while creating exceptional friendships with our English speaker.'
      },
      t2: {
        name: 'Petit Family',
        location: 'Belfort Territory',
        text: 'More than just an English lesson, it is a true cultural exchange that enriched our entire family.'
      },
      t3: {
        name: 'Sarah Johnson',
        location: 'England',
        text: 'I loved my stay with TEREKA. The family welcomed me warmly and I discovered the beautiful Belfort region.'
      }
    }
  }
};
